import InfoIcon from "@mui/icons-material/Info";
import { Tooltip, Typography } from "@mui/material";
import { useAppReduxSelector } from "hooks/reduxHooks";
import styled from "styled-components";
import { WellMapping } from "../WellMapping";

const StyledTransverVolHeaderDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 8px;
`;

export const SourceToNucMapping = () => {
  const worklistValues = useAppReduxSelector(
    (state) => state.WorklistTools.NucleofectionTool.present.worklistValues
  );

  const columns = [
    { key: "sourceWellId", name: "Src Pos", resizable: true },

    { key: "destWellId", name: "Nuc Pos", resizable: true },
    {
      key: "transferVol",
      name: "Transfer Vol",
      resizable: true,
      headerRenderer: () => (
        <StyledTransverVolHeaderDiv>
          <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
            Transfer Vol
          </Typography>
          <Tooltip
            title={
              "Compound reagent volume transferred from Source to Nucleofection plate wells "
            }
            placement="top"
          >
            <InfoIcon
              sx={{
                alignSelf: "flex-start",
                fontSize: "medium",
              }}
            />
          </Tooltip>
        </StyledTransverVolHeaderDiv>
      ),
      editable: false,
    },
  ];

  return (
    <WellMapping
      columns={columns}
      worklistValues={worklistValues.sourceToNuc}
    />
  );
};
